import React, { useState, useEffect } from 'react';
import { X } from 'lucide-react';
import './EventFormModal.css'; // reutilizăm stilurile .pe-* și .rf-*

export default function CoachFormModal({ onClose, onCoachAdded, editData }) {
  const [formData, setFormData] = useState({
    first_name: '',
    last_name: '',
    birth_year: '',
    license_number: '',
    email: '',
    phone: ''
  });

  useEffect(() => {
    if (editData) {
      setFormData({
        first_name: editData.first_name || '',
        last_name: editData.last_name || '',
        birth_year: editData.birth_year || '',
        license_number: editData.license_number || '',
        email: editData.email || '',
        phone: editData.phone || ''
      });
    }
  }, [editData]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const token = localStorage.getItem('jwtToken');
    const url = editData
      ? 'https://www.fro.ro/api/coaches/edit.php'
      : 'https://www.fro.ro/api/coaches/create.php';

    const payload = editData ? { ...formData, id: editData.id } : formData;

    try {
      const response = await fetch(url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + token
        },
        body: JSON.stringify(payload)
      });

      const text = await response.text();
      try {
        const result = JSON.parse(text);
        if (result.success) {
          onClose();
          onCoachAdded && onCoachAdded();
        } else {
          alert('Eroare: ' + result.message);
        }
      } catch {
        alert('Răspuns invalid de la server:\n\n' + text);
      }
    } catch (error) {
      alert('Eroare rețea: ' + error.message);
    }
  };

  return (
    <div className="pe-backdrop" onClick={onClose}>
      <div
        className="pe-modal rf-modal"
        style={{ maxWidth: '520px' }}
        onClick={(e) => e.stopPropagation()}
        role="dialog"
        aria-modal="true"
      >
        {/* HEADER */}
        <div className="pe-head">
          <h3 className="pe-title">{editData ? 'Editează antrenor' : 'Adaugă antrenor'}</h3>
          <button className="pe-close" aria-label="Închide" onClick={onClose}>
            <X size={20} />
          </button>
        </div>

        {/* BODY */}
        <form
          className="rf-body"
          onSubmit={handleSubmit}
          style={{ maxHeight: 'calc(92vh - 140px)', overflowY: 'auto' }}
        >
          {/* forțăm 1 coloană */}
          <div className="rf-grid" style={{ display: 'grid', gridTemplateColumns: '1fr', gap: 14 }}>

            {/* 🔹 Nr. legitimație — mutat primul */}
            <div className="rf-field">
              <label htmlFor="license_number">Nr. legitimație</label>
              <input
                id="license_number"
                name="license_number"
                type="text"
                value={formData.license_number}
                onChange={handleInputChange}
                autoFocus
              />
            </div>

            <div className="rf-field">
              <label htmlFor="first_name">Prenume <span className="req">*</span></label>
              <input
                id="first_name"
                name="first_name"
                type="text"
                required
                autoComplete="given-name"
                value={formData.first_name}
                onChange={handleInputChange}
              />
            </div>

            <div className="rf-field">
              <label htmlFor="last_name">Nume <span className="req">*</span></label>
              <input
                id="last_name"
                name="last_name"
                type="text"
                required
                autoComplete="family-name"
                value={formData.last_name}
                onChange={handleInputChange}
              />
            </div>

            <div className="rf-field">
              <label htmlFor="birth_year">An naștere <span className="req">*</span></label>
              <input
                id="birth_year"
                name="birth_year"
                type="number"
                inputMode="numeric"
                min="1930"
                max={new Date().getFullYear() - 10}
                required
                value={formData.birth_year}
                onChange={handleInputChange}
              />
            </div>

            <div className="rf-field">
              <label htmlFor="email">Email</label>
              <input
                id="email"
                name="email"
                type="email"
                autoComplete="email"
                value={formData.email}
                onChange={handleInputChange}
              />
            </div>

            <div className="rf-field">
              <label htmlFor="phone">Telefon</label>
              <input
                id="phone"
                name="phone"
                type="text"
                autoComplete="tel"
                value={formData.phone}
                onChange={handleInputChange}
              />
            </div>
          </div>

          <div className="rf-actions">
            <button type="button" className="btn btn-ghost" onClick={onClose}>Anulează</button>
            <button type="submit" className="btn btn-primary">
              {editData ? 'Salvează' : 'Adaugă'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
